import createIcon from '../../createIcon';

/**
 * @component @name SportsHockey
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxN1YyMEg0VjE2SDNDMi40NSAxNiAyIDE2LjQ1IDIgMTdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNOSAxNkg1VjIwTDkuNjkgMTkuOTlDMTAuMDcgMTkuOTkgMTAuNDEgMTkuNzggMTAuNTggMTkuNDRMMTEuNDUgMTcuNTRMOS44NiAxNC4wNkw5IDE2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIxLjcxIDE2LjI5QzIxLjUzIDE2LjExIDIxLjI4IDE2IDIxIDE2SDIwVjIwSDIyVjE3QzIyIDE2LjcyIDIxLjg5IDE2LjQ3IDIxLjcxIDE2LjI5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEzLjYgMTIuODRMMTcuNjUgNEgxNC4zTDEyLjU0IDcuOTdMMTIuMDUgOS4wN0wxMiA5LjIxTDkuNyA0SDYuMzVMMTEuOTIgMTYuMTZMMTIgMTYuMzRMMTMuNDIgMTkuNDRDMTMuNTkgMTkuNzggMTMuOTMgMTkuOTkgMTQuMzEgMTkuOTlMMTkgMjBWMTZIMTVMMTMuNiAxMi44NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsHockey = createIcon('SportsHockey', [
  ['path', { d: 'M2 17V20H4V16H3C2.45 16 2 16.45 2 17Z', key: '926k0i' }],
  [
    'path',
    {
      d: 'M9 16H5V20L9.69 19.99C10.07 19.99 10.41 19.78 10.58 19.44L11.45 17.54L9.86 14.06L9 16Z',
      key: 'ui98nw',
    },
  ],
  [
    'path',
    {
      d: 'M21.71 16.29C21.53 16.11 21.28 16 21 16H20V20H22V17C22 16.72 21.89 16.47 21.71 16.29Z',
      key: 'ujyda1',
    },
  ],
  [
    'path',
    {
      d: 'M13.6 12.84L17.65 4H14.3L12.54 7.97L12.05 9.07L12 9.21L9.7 4H6.35L11.92 16.16L12 16.34L13.42 19.44C13.59 19.78 13.93 19.99 14.31 19.99L19 20V16H15L13.6 12.84Z',
      key: 'dwfpma',
    },
  ],
]);

export default SportsHockey;
